<div class="reset-password-container">
  <div class="border-auth-container">
    <div class="logo-card">
      <div class="logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="141"
          height="35"
          viewBox="0 0 141 35"
          fill="none"
        >
          <mask
            id="mask0_7493_1471"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="29"
            y="0"
            width="27"
            height="35"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M29.3159 0.33374H55.3554V34.857H29.3159V0.33374Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_7493_1471)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M34.5235 6.19678V20.5275C34.5235 20.5275 34.5235 21.1801 35.1747 21.1801H49.4963C50.1475 21.1801 50.1475 20.5275 50.1475 20.5275V6.19678C50.1475 5.54512 49.4963 5.54512 49.4963 5.54512H35.1747C35.1747 5.54512 34.5235 5.54512 34.5235 6.19678ZM48.8443 0.33374C49.4965 0.33374 50.1477 0.33374 50.7989 0.985403L54.7042 4.89342C55.3554 5.54508 55.3554 6.19674 55.3554 6.84743V17.2701C55.3554 18.5734 54.7042 19.8758 53.4027 20.5274L41.0327 25.7398C39.7313 26.3914 38.4289 26.3914 38.4289 26.3914H35.1748C35.1748 26.3914 34.5236 26.3914 34.5236 27.0431V31.2515C34.4855 31.958 33.9702 32.9697 33.3014 33.1987L29.3159 34.8572V0.33374H48.8443Z"
              fill="white"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M63.4844 10.7568H77.1548C77.806 10.7568 78.4572 10.7568 79.1084 11.4085L83.0147 15.3165C83.6649 15.9681 83.6649 16.4564 83.6649 17.2705V19.8761C83.6649 20.5278 83.6649 21.1795 83.0147 21.8311L79.1084 25.7401C78.4572 26.3918 77.806 26.3918 77.1548 26.3918H57.6255V21.1795H77.806C78.4572 21.1795 78.4572 20.5278 78.4572 20.5278V16.6198C78.4572 15.9681 77.806 15.9681 77.806 15.9681H64.1356C63.4844 15.9681 62.8332 15.9681 62.183 15.3165L58.2767 11.4085C57.6255 10.7568 57.6255 9.45347 57.6255 9.45347C57.6255 8.11002 58.2767 6.84779 59.5791 6.19711L71.9471 0.985769C73.2486 0.334106 74.551 0.334106 74.551 0.334106H83.6649V5.54545H63.4844C63.1187 5.54545 62.8332 5.83018 62.8332 6.19711V10.1051C62.8332 10.4711 63.1187 10.7568 63.4844 10.7568Z"
            fill="white"
          />
          <mask
            id="mask1_7493_1471"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="27"
            height="27"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.0288086 0.333496H26.0683V26.3909H0.0288086V0.333496Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_7493_1471)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.8604 20.528C20.8604 21.1796 20.2092 21.1796 20.2092 21.1796H5.88751C5.88751 21.1796 5.2363 21.1796 5.2363 20.528V9.81566V6.19727C5.2363 5.92819 5.39177 5.70608 5.61666 5.60432C5.62839 5.6004 5.64013 5.59453 5.65088 5.59062C5.72422 5.56322 5.80342 5.54463 5.88751 5.54463H19.2235H20.2092C20.2092 5.54463 20.8604 5.54463 20.8604 6.19727V20.528ZM25.4171 4.89293L21.5118 0.984914C20.8606 0.333252 20.2094 0.333252 19.5582 0.333252H19.2237H18.0377H16.9543C16.9543 0.333252 15.6529 0.333252 14.3505 0.984914L1.98145 6.19723C0.717171 6.82933 0.0718312 8.03774 0.0356531 9.33813L0.0288086 9.34498V11.391V14.5299V19.8763C0.0288086 20.5279 0.0288086 21.1796 0.680015 21.8313L4.5853 25.7393C5.2365 26.3909 5.88771 26.3909 6.53892 26.3909H19.5582C20.2094 26.3909 20.8606 26.3909 21.5118 25.7393L25.4171 21.8313C26.0683 21.1796 26.0683 20.5279 26.0683 19.8763V6.84792C26.0683 6.19723 26.0683 5.54459 25.4171 4.89293Z"
              fill="white"
            />
          </g>
          <mask
            id="mask2_7493_1471"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="88"
            y="0"
            width="24"
            height="27"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M88.8667 0.333496H111.974V26.3909H88.8667V0.333496Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_7493_1471)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M105.142 21.1796H111.974V26.3909H88.8667V21.1796H98.6328C98.6328 21.1796 99.2831 21.1796 99.2831 20.5279V6.19626C99.2831 5.54459 98.6328 5.54459 98.6328 5.54459H88.8667V0.333252H97.9816C98.6328 0.333252 99.2831 0.333252 99.9343 0.984914L103.841 4.89293C104.491 5.54459 104.491 6.19626 104.491 6.84792V20.5279C104.491 21.1796 105.142 21.1796 105.142 21.1796Z"
              fill="white"
            />
          </g>
          <mask
            id="mask3_7493_1471"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="134"
            y="0"
            width="7"
            height="8"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M134.096 0.33374H141V7.24175H134.096V0.33374Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_7493_1471)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M136.669 5.54808H138.428C138.428 5.54808 139.307 5.54808 139.307 4.66843V2.90718C139.307 2.02754 138.428 2.02754 138.428 2.02754H136.669C136.669 2.02754 135.79 2.02754 135.79 2.90718V4.66843C135.79 5.54808 136.669 5.54808 136.669 5.54808ZM134.671 2.06074L135.822 0.909082C136.362 0.368965 136.974 0.33374 137.548 0.33374C138.123 0.33374 138.735 0.368965 139.275 0.909082L140.424 2.06074C140.964 2.59988 141 3.21143 141 3.78775C141 4.36309 140.964 4.97463 140.424 5.51475L139.275 6.66641C138.735 7.20555 138.123 7.24175 137.548 7.24175C136.974 7.24175 136.362 7.20555 135.822 6.66641L134.671 5.51475C134.132 4.97463 134.096 4.36309 134.096 3.78775C134.096 3.21143 134.132 2.59988 134.671 2.06074Z"
              fill="white"
            />
          </g>
          <mask
            id="mask4_7493_1471"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="114"
            y="0"
            width="26"
            height="27"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M114.732 0.333496H139.773V26.3909H114.732V0.333496Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_7493_1471)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M137.838 21.1796H137.417H131.007C131.007 21.1796 130.356 21.1796 130.356 20.5279V6.84792C130.356 6.19626 130.356 5.54459 129.705 4.89293L125.799 0.984914C125.147 0.333252 124.496 0.333252 123.846 0.333252H114.732V5.54459H124.496C124.496 5.54459 125.147 5.54459 125.147 6.19626V20.5279C125.147 21.1796 124.496 21.1796 124.496 21.1796H124.081H114.732V26.3909H124.081H126.285H126.35C126.35 26.3909 127.651 26.3909 128.954 25.7393L139.773 21.1796H137.838Z"
              fill="white"
            />
          </g>
        </svg>
      </div>
      <div class="login-card">
        <h1 class="title">{{ 'auth.resetPassword.title' | translate }}</h1>
        <form class="login-form">
          <ops-input
            [label]="'auth.resetPassword.password' | translate"
            (changed)="onPasswordChange($event)"
            [value]="password"
            (validationError)="onErrorHandler($event, 'password')"
            type="password"
            formName="password"
          />

          <ops-input
            [label]="'auth.resetPassword.confirmPassword' | translate"
            type="password"
            [value]="confirmPassword"
            formName="confirmPassword"
            (changed)="onPasswordChangeRepeat($event)"
            (validationError)="onErrorHandler($event, 'confirmPassword')"
          />

          <span class="password-missmatch" *ngIf="passwordMissmatch">{{
            'auth.resetPassword.passwordMismatch' | translate
          }}</span>

          <button
            type="button"
            [disabled]="isDisabled"
            [class.disabled]="isDisabled"
            (click)="updatePassword()"
            class="login-btn"
          >
            {{ 'auth.resetPassword.updatePassword' | translate }}
          </button>

          <div class="signup">
            <span
              >{{ 'auth.resetPassword.abortPasswordChange' | translate }} </span
            ><a href="/login">{{
              'auth.resetPassword.loginHere' | translate
            }}</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
